import { useState, createContext, useMemo, useCallback } from 'react';
import ToastNotifications from './ToastNotification';

const ToastNotificationContext = createContext({
  toastNotificationConfig: [],
  setToastNotificationConfig: () => {},
});

const makeToastId = () =>
  `${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 11)}`;

const ToastNotificationContextProvider = ({ children }) => {
  const [toastNotificationConfig, setToastNotificationConfigState] = useState(
    []
  );

  const setToastNotificationConfig = useCallback(config => {
    setToastNotificationConfigState(prev => [
      ...prev,
      {
        ...config,
        id: config.id ?? makeToastId(),
        open: config.open !== false,
      },
    ]);
  }, []);

  const dismissToast = useCallback(id => {
    setToastNotificationConfigState(prev => prev.filter(n => n.id !== id));
  }, []);

  const value = useMemo(
    () => ({ toastNotificationConfig, setToastNotificationConfig }),
    [setToastNotificationConfig, toastNotificationConfig]
  );

  return (
    <ToastNotificationContext.Provider value={value}>
      <div className="toast-notification" aria-live="polite">
        {toastNotificationConfig.map(notification => (
          <ToastNotifications
            key={notification.id}
            open={notification.open}
            kind={notification.kind}
            title={notification.title}
            subtitle={notification.subtitle}
            onClose={() => dismissToast(notification.id)}
          />
        ))}
      </div>
      {children}
    </ToastNotificationContext.Provider>
  );
};

export { ToastNotificationContext, ToastNotificationContextProvider };
